import { useEffect, useMemo } from "react";

// Interface for useBroadcastChannel parameters
interface UseBroadcastChannelParams {
	channelName: string;
	messageHandler: (event: MessageEvent) => void;
}

// Interface for return value
interface UseBroadcastChannelReturn {
	broadcast: (message: wts_approved_any) => void;
}

function useBroadcastChannel({channelName, messageHandler}: UseBroadcastChannelParams): UseBroadcastChannelReturn
{
	const channel = useMemo(
		() => new BroadcastChannel(channelName),
		[channelName]
	);
	const receiveChannel = useMemo(
		() => new BroadcastChannel(channelName),
		[channelName]
	);

	const broadcast = (message: wts_approved_any) => {
		channel.postMessage(message);
	};

	useEffect(() => {
		channel.addEventListener("message", messageHandler);
		receiveChannel.addEventListener("message", messageHandler);

		return () => {
			channel.removeEventListener("message", messageHandler);
			receiveChannel.removeEventListener("message", messageHandler);
		};
	}, [channel, receiveChannel, messageHandler]);

	return {
		broadcast,
	};
};

export default useBroadcastChannel;